// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetCurrentEmployeeQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetCurrentEmployeeQuery = { __typename?: 'Query' } & {
  currentEmployee: { __typename?: 'CurrentEmployee' } & Pick<Types.CurrentEmployee, 'id'> & {
      employee: { __typename?: 'Employee' } & Pick<Types.Employee, 'status'> & {
          currentMainContract: Types.Maybe<
            { __typename?: 'EmployeeContract' } & Pick<Types.EmployeeContract, 'contractType'> & {
                company: { __typename?: 'Company' } & Pick<Types.Company, 'id' | 'countryId'>;
              }
          >;
        };
      permission: Types.Maybe<
        { __typename?: 'EmployeePermission' } & Pick<
          Types.EmployeePermission,
          'id' | 'accessSpecificEmployees' | 'companyIds' | 'employeeIds' | 'idpFullAccess' | 'role'
        >
      >;
      accessFlag: { __typename?: 'EmployeePermissionAccessFlag' } & Pick<
        Types.EmployeePermissionAccessFlag,
        | 'employeeAdd'
        | 'employeeAlertListView'
        | 'employeeExternalAccountListView'
        | 'employeePendingChangesListView'
        | 'employeePersonalInformationViewInEmployeeList'
        | 'isAdminPrivate'
        | 'isAdminStandard'
        | 'isSuperAdmin'
        | 'performanceReviewResultsList'
        | 'performanceReviewStage'
        | 'probationReviewManage'
        | 'reportView'
        | 'settingNotificationView'
        | 'settingView'
      >;
    };
};

export type GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['ID']['input'];
}>;

export type GetCurrentEmployeePermissionAccessFlagEmployeeQuery = { __typename?: 'Query' } & {
  currentEmployee: { __typename?: 'CurrentEmployee' } & {
    accessFlag: { __typename?: 'EmployeePermissionAccessFlag' } & Pick<
      Types.EmployeePermissionAccessFlag,
      | 'employeeDelete'
      | 'employeeExternalAccountModify'
      | 'employeeExternalAccountView'
      | 'employeeGeneralInformationEdit'
      | 'employeeJobContractHistoryDelete'
      | 'employeeJobContractHistoryEdit'
      | 'employeeJobContractHistoryView'
      | 'employeeManagerialAccountingView'
      | 'employeeManagerialAccountingEdit'
      | 'employeeOffBoardingEdit'
      | 'employeeOffBoardingView'
      | 'employeePermissionEdit'
      | 'employeePermissionView'
      | 'employeePersonalInformationEdit'
      | 'employeePersonalInformationDelete'
      | 'employeePersonalInformationView'
      | 'isDirectReport'
      | 'isMyOwnData'
      | 'performanceReviewModifyDepartmentLead'
      | 'performanceReviewView'
      | 'probationReviewModify'
      | 'probationReviewView'
    >;
  };
};

export type GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['ID']['input'];
  period: Types.PerformanceReviewPeriodInput;
}>;

export type GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery = { __typename?: 'Query' } & {
  currentEmployee: { __typename?: 'CurrentEmployee' } & {
    accessFlag: { __typename?: 'EmployeePermissionAccessFlag' } & Pick<
      Types.EmployeePermissionAccessFlag,
      'performanceReviewModify' | 'performanceReviewModifySetting'
    >;
  };
};

export type GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['ID']['input'];
  periods: Array<Types.PerformanceReviewPeriodInput> | Types.PerformanceReviewPeriodInput;
}>;

export type GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery = { __typename?: 'Query' } & {
  currentEmployee: { __typename?: 'CurrentEmployee' } & {
    accessFlag: { __typename?: 'EmployeePermissionAccessFlag' } & {
      performanceReviewDelete: Array<
        { __typename?: 'PerformanceReviewDelete' } & Pick<Types.PerformanceReviewDelete, 'isDeletable'> & {
            period: { __typename?: 'PerformanceReviewPeriod' } & Pick<
              Types.PerformanceReviewPeriod,
              'year' | 'quarter'
            >;
          }
      >;
    };
  };
};

export type GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;

export type GetCurrentEmployeePermissionAccessFlagNotificationQuery = { __typename?: 'Query' } & {
  currentEmployee: { __typename?: 'CurrentEmployee' } & {
    accessFlag: { __typename?: 'EmployeePermissionAccessFlag' } & Pick<
      Types.EmployeePermissionAccessFlag,
      'settingNotificationEdit'
    >;
  };
};

export const GetCurrentEmployeeDocument = /*#__PURE__*/ gql`
    query getCurrentEmployee {
  currentEmployee {
    id
    employee {
      status
      currentMainContract {
        contractType
        company {
          id
          countryId
        }
      }
    }
    permission {
      id
      accessSpecificEmployees
      companyIds
      employeeIds
      idpFullAccess
      role
    }
    accessFlag {
      employeeAdd
      employeeAlertListView
      employeeExternalAccountListView
      employeePendingChangesListView
      employeePersonalInformationViewInEmployeeList
      isAdminPrivate
      isAdminStandard
      isSuperAdmin
      performanceReviewResultsList
      performanceReviewStage
      probationReviewManage
      reportView
      settingNotificationView
      settingView
    }
  }
}
    `;

/**
 * __useGetCurrentEmployeeQuery__
 *
 * To run a query within a React component, call `useGetCurrentEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentEmployeeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentEmployeeQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCurrentEmployeeQuery, GetCurrentEmployeeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCurrentEmployeeQuery, GetCurrentEmployeeQueryVariables>(
    GetCurrentEmployeeDocument,
    options,
  );
}
export function useGetCurrentEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentEmployeeQuery, GetCurrentEmployeeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCurrentEmployeeQuery, GetCurrentEmployeeQueryVariables>(
    GetCurrentEmployeeDocument,
    options,
  );
}
// @ts-expect-error
export function useGetCurrentEmployeeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentEmployeeQuery, GetCurrentEmployeeQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCurrentEmployeeQuery, GetCurrentEmployeeQueryVariables>;
export function useGetCurrentEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCurrentEmployeeQuery, GetCurrentEmployeeQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCurrentEmployeeQuery | undefined, GetCurrentEmployeeQueryVariables>;
export function useGetCurrentEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCurrentEmployeeQuery, GetCurrentEmployeeQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCurrentEmployeeQuery, GetCurrentEmployeeQueryVariables>(
    GetCurrentEmployeeDocument,
    options,
  );
}
export type GetCurrentEmployeeQueryHookResult = ReturnType<typeof useGetCurrentEmployeeQuery>;
export type GetCurrentEmployeeLazyQueryHookResult = ReturnType<typeof useGetCurrentEmployeeLazyQuery>;
export type GetCurrentEmployeeSuspenseQueryHookResult = ReturnType<typeof useGetCurrentEmployeeSuspenseQuery>;
export const GetCurrentEmployeePermissionAccessFlagEmployeeDocument = /*#__PURE__*/ gql`
    query getCurrentEmployeePermissionAccessFlagEmployee($employeeId: ID!) {
  currentEmployee {
    accessFlag {
      employeeDelete(employeeId: $employeeId)
      employeeExternalAccountModify(employeeId: $employeeId)
      employeeExternalAccountView
      employeeGeneralInformationEdit(employeeId: $employeeId)
      employeeJobContractHistoryDelete(employeeId: $employeeId)
      employeeJobContractHistoryEdit(employeeId: $employeeId)
      employeeJobContractHistoryView(employeeId: $employeeId)
      employeeManagerialAccountingView(employeeId: $employeeId)
      employeeManagerialAccountingEdit(employeeId: $employeeId)
      employeeOffBoardingEdit(employeeId: $employeeId)
      employeeOffBoardingView
      employeePermissionEdit(employeeId: $employeeId)
      employeePermissionView
      employeePersonalInformationEdit(employeeId: $employeeId)
      employeePersonalInformationDelete(employeeId: $employeeId)
      employeePersonalInformationView(employeeId: $employeeId)
      isDirectReport(employeeId: $employeeId)
      isMyOwnData(employeeId: $employeeId)
      performanceReviewModifyDepartmentLead(employeeId: $employeeId)
      performanceReviewView(employeeId: $employeeId)
      probationReviewModify(employeeId: $employeeId)
      probationReviewView(employeeId: $employeeId)
    }
  }
}
    `;

/**
 * __useGetCurrentEmployeePermissionAccessFlagEmployeeQuery__
 *
 * To run a query within a React component, call `useGetCurrentEmployeePermissionAccessFlagEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentEmployeePermissionAccessFlagEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentEmployeePermissionAccessFlagEmployeeQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetCurrentEmployeePermissionAccessFlagEmployeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagEmployeeQuery,
    GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables
  > &
    ({ variables: GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrentEmployeePermissionAccessFlagEmployeeQuery,
    GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagEmployeeDocument, options);
}
export function useGetCurrentEmployeePermissionAccessFlagEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagEmployeeQuery,
    GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrentEmployeePermissionAccessFlagEmployeeQuery,
    GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagEmployeeDocument, options);
}
// @ts-expect-error
export function useGetCurrentEmployeePermissionAccessFlagEmployeeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagEmployeeQuery,
    GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentEmployeePermissionAccessFlagEmployeeQuery,
  GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables
>;
export function useGetCurrentEmployeePermissionAccessFlagEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentEmployeePermissionAccessFlagEmployeeQuery,
        GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentEmployeePermissionAccessFlagEmployeeQuery | undefined,
  GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables
>;
export function useGetCurrentEmployeePermissionAccessFlagEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentEmployeePermissionAccessFlagEmployeeQuery,
        GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentEmployeePermissionAccessFlagEmployeeQuery,
    GetCurrentEmployeePermissionAccessFlagEmployeeQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagEmployeeDocument, options);
}
export type GetCurrentEmployeePermissionAccessFlagEmployeeQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagEmployeeQuery
>;
export type GetCurrentEmployeePermissionAccessFlagEmployeeLazyQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagEmployeeLazyQuery
>;
export type GetCurrentEmployeePermissionAccessFlagEmployeeSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagEmployeeSuspenseQuery
>;
export const GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditDocument = /*#__PURE__*/ gql`
    query getCurrentEmployeePermissionAccessFlagPerformanceReviewEdit($employeeId: ID!, $period: PerformanceReviewPeriodInput!) {
  currentEmployee {
    accessFlag {
      performanceReviewModify(employeeId: $employeeId, period: $period)
      performanceReviewModifySetting(employeeId: $employeeId, period: $period)
    }
  }
}
    `;

/**
 * __useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery__
 *
 * To run a query within a React component, call `useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables
  > &
    (
      | { variables: GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditDocument, options);
}
export function useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditDocument, options);
}
// @ts-expect-error
export function useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery,
  GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables
>;
export function useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery,
        GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery | undefined,
  GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables
>;
export function useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery,
        GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditDocument, options);
}
export type GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditQuery
>;
export type GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditLazyQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditLazyQuery
>;
export type GetCurrentEmployeePermissionAccessFlagPerformanceReviewEditSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagPerformanceReviewEditSuspenseQuery
>;
export const GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteDocument = /*#__PURE__*/ gql`
    query getCurrentEmployeePermissionAccessFlagPerformanceReviewDelete($employeeId: ID!, $periods: [PerformanceReviewPeriodInput!]!) {
  currentEmployee {
    accessFlag {
      performanceReviewDelete(employeeId: $employeeId, periods: $periods) {
        period {
          year
          quarter
        }
        isDeletable
      }
    }
  }
}
    `;

/**
 * __useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery__
 *
 * To run a query within a React component, call `useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      periods: // value for 'periods'
 *   },
 * });
 */
export function useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables
  > &
    (
      | { variables: GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteDocument, options);
}
export function useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteDocument, options);
}
// @ts-expect-error
export function useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery,
  GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables
>;
export function useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery,
        GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery | undefined,
  GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables
>;
export function useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery,
        GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery,
    GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteDocument, options);
}
export type GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteQuery
>;
export type GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteLazyQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteLazyQuery
>;
export type GetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagPerformanceReviewDeleteSuspenseQuery
>;
export const GetCurrentEmployeePermissionAccessFlagNotificationDocument = /*#__PURE__*/ gql`
    query getCurrentEmployeePermissionAccessFlagNotification($companyId: ID!) {
  currentEmployee {
    accessFlag {
      settingNotificationEdit(companyId: $companyId)
    }
  }
}
    `;

/**
 * __useGetCurrentEmployeePermissionAccessFlagNotificationQuery__
 *
 * To run a query within a React component, call `useGetCurrentEmployeePermissionAccessFlagNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentEmployeePermissionAccessFlagNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentEmployeePermissionAccessFlagNotificationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCurrentEmployeePermissionAccessFlagNotificationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagNotificationQuery,
    GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables
  > &
    (
      | { variables: GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrentEmployeePermissionAccessFlagNotificationQuery,
    GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagNotificationDocument, options);
}
export function useGetCurrentEmployeePermissionAccessFlagNotificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagNotificationQuery,
    GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrentEmployeePermissionAccessFlagNotificationQuery,
    GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagNotificationDocument, options);
}
// @ts-expect-error
export function useGetCurrentEmployeePermissionAccessFlagNotificationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentEmployeePermissionAccessFlagNotificationQuery,
    GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentEmployeePermissionAccessFlagNotificationQuery,
  GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables
>;
export function useGetCurrentEmployeePermissionAccessFlagNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentEmployeePermissionAccessFlagNotificationQuery,
        GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentEmployeePermissionAccessFlagNotificationQuery | undefined,
  GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables
>;
export function useGetCurrentEmployeePermissionAccessFlagNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentEmployeePermissionAccessFlagNotificationQuery,
        GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentEmployeePermissionAccessFlagNotificationQuery,
    GetCurrentEmployeePermissionAccessFlagNotificationQueryVariables
  >(GetCurrentEmployeePermissionAccessFlagNotificationDocument, options);
}
export type GetCurrentEmployeePermissionAccessFlagNotificationQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagNotificationQuery
>;
export type GetCurrentEmployeePermissionAccessFlagNotificationLazyQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagNotificationLazyQuery
>;
export type GetCurrentEmployeePermissionAccessFlagNotificationSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentEmployeePermissionAccessFlagNotificationSuspenseQuery
>;
